import React from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

const PrimaryTabs = ({ activeTab, onTabChange, tabs = [] }) => {
  const navigate = useNavigate();

  const handleTabChange = (event, newValue) => {
    if (onTabChange) {
      onTabChange(newValue);
    } else if (tabs[newValue]?.route) {
      navigate(tabs[newValue].route);
    }
  };

  return (
    <Box sx={{ mb: { xs: 2, sm: 2.5, md: 3 } }}>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        sx={{
          '& .MuiTab-root': {
            textTransform: 'none',
            fontFamily: 'IBM Plex Sans, sans-serif',
            fontSize: { xs: '0.75rem', sm: '0.8125rem', md: '0.875rem' },
            fontWeight: 500,
            minHeight: { xs: 40, sm: 44, md: 48 },
            color: '#3F3F3F',
            padding: 0,
            marginRight: { xs: 1, sm: 2, md: 2.5 },
            '&:last-child': {
              marginRight: 0,
            },
          },
          '& .Mui-selected': {
            color: '#000000',
            fontWeight: 600,
            borderBottom: '4px solid #3E9663',
          },
          '& .MuiTabs-indicator': {
            display: 'none',
          },
        }}
      >
        {tabs.map((tab, index) => (
          <Tab
            key={index}
            icon={
              tab.icon ? (
                typeof tab.icon === 'string' ? (
                  <Box
                    component="img"
                    src={tab.icon}
                    alt={tab.label}
                    sx={{ width: { xs: 16, sm: 17, md: 18 }, height: { xs: 16, sm: 17, md: 18 } }}
                  />
                ) : (
                  tab.icon
                )
              ) : null
            }
            iconPosition={tab.iconPosition || 'start'}
            label={tab.label}
          />
        ))}
      </Tabs>
    </Box>
  );
};

PrimaryTabs.propTypes = {
  activeTab: PropTypes.number.isRequired,
  onTabChange: PropTypes.func,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      iconPosition: PropTypes.string,
      route: PropTypes.string,
    })
  ),
};

export default PrimaryTabs;
